export enum ViewType {
    TABLE = 'Table',
    GRAPH = 'Graph',
    LEGEND = 'Legend',
    CARDS = 'CARDS',
    KANBAN = 'KANBAN',
    BOTH = 'Both',
    STACKED_BAR_GRAPH = 'STACKED_BAR_GRAPH'
}
